import React, { useState } from 'react';
import { FiSettings } from 'react-icons/fi';

const AddNamuna9 = () => {
  const [formType, setFormType] = useState('new'); // 'new' or 'edit'
  
  // Word data mapping
  const wordData = {
    '1': { propertyNo: '101', name: 'shubham' },
    '2': { propertyNo: '102', name: 'sangram' },
    '3': { propertyNo: '103', name: 'sagar' }
  };
  
  const [formData, setFormData] = useState({
    receiptNo: '',
    date: '',
    grantType: '',
    ownerName: '',
    propertyNo: '',
    selectedName: '', // New field for selected name
    showPropertyNo: false,
    
    // Table data
    current: {
      quantity: '',
      rate: '',
      discount: '',
      discountPercent: '',
      amount: '',
      total: ''
    },
    previous: {
      amount: '',
      total: ''
    },
    arrears: {
      amount: '',
      total: ''
    },
    subtotal1: '',
    other: {
      amount: '',
      total: ''
    },
    normalWaterSupply: {
      amount: '',
      total: ''
    },
    specialWaterSupply: {
      amount: '',
      total: ''
    },
    subtotal2: '',
    grandTotal: ''
  });

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  // Handle word name change to auto-populate property number and name
  const handleWordNameChange = (value) => {
    setFormData({
      ...formData,
      ownerName: value,
      propertyNo: wordData[value]?.propertyNo || '',
      selectedName: wordData[value]?.name || ''
    });
  };

  const handleTableInputChange = (section, field, value) => {
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [field]: value
      }
    });
  };

  const handleSubmit = () => {
    // Get existing data from localStorage or initialize empty array
    const existingData = JSON.parse(localStorage.getItem('namuna9Data') || '[]');
    
    // Create new entry
    const newEntry = {
      id: Date.now(),
      serialNo: existingData.length + 1,
      date: formData.date,
      billNo: formData.receiptNo,
      wordName: formData.ownerName,
      propertyNo: formData.propertyNo,
      name: formData.selectedName,
      // Add other form fields as needed
      ...formData
    };
    
    // Save to localStorage
    existingData.push(newEntry);
    localStorage.setItem('namuna9Data', JSON.stringify(existingData));
    
    console.log('Form submitted:', formData);
    alert('फॉर्म सबमिट केला!');
    
    // Reset form after submission
    handleReset();
  };

  const handleReset = () => {
    setFormData({
      receiptNo: '',
      date: '',
      grantType: '',
      ownerName: '',
      propertyNo: '',
      selectedName: '',
      showPropertyNo: false,
      current: { quantity: '', rate: '', discount: '', discountPercent: '', amount: '', total: '' },
      previous: { amount: '', total: '' },
      arrears: { amount: '', total: '' },
      subtotal1: '',
      other: { amount: '', total: '' },
      normalWaterSupply: { amount: '', total: '' },
      specialWaterSupply: { amount: '', total: '' },
      subtotal2: '',
      grandTotal: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-700 to-blue-600 text-white p-4 rounded-t-lg shadow-md flex justify-between items-center">
        <h1 className="text-xl font-bold">नमुना नं ९</h1>
        <button className="bg-cyan-400 hover:bg-cyan-500 p-2 rounded transition-colors">
          <FiSettings size={20} />
        </button>
      </div>

      {/* Main Form */}
      <div className="bg-white shadow-lg rounded-b-lg p-6">
        {/* Radio Buttons */}
        <div className="flex items-center gap-8 mb-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="formType"
              value="new"
              checked={formType === 'new'}
              onChange={(e) => setFormType(e.target.value)}
              className="w-4 h-4 text-blue-600"
            />
            <span className="text-sm font-medium">मालमत्ता कर-नमुना</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="formType"
              value="edit"
              checked={formType === 'edit'}
              onChange={(e) => setFormType(e.target.value)}
              className="w-4 h-4 text-blue-600"
            />
            <span className="text-sm font-medium">नमुनादार एडिट/रिव्हिजन</span>
          </label>
          <button className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded text-sm font-medium transition-colors ml-auto">
            शोध
          </button>
        </div>

        {/* Form Fields Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              पावती क्रमांक :
            </label>
            <input
              type="text"
              value={formData.receiptNo}
              onChange={(e) => handleInputChange('receiptNo', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="3"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              तारीख :
            </label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => handleInputChange('date', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              वॉर्डचे नाव :
            </label>
            <div className="flex items-center gap-2">
              <select
                value={formData.ownerName}
                onChange={(e) => handleWordNameChange(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">निवडा</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
              <button className="text-red-500 hover:text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              मालमत्ता क्रमांक :
            </label>
            <div className="flex items-center gap-2">
              <select
                value={formData.propertyNo}
                onChange={(e) => handleInputChange('propertyNo', e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">निवडा</option>
                {formData.propertyNo && <option value={formData.propertyNo}>{formData.propertyNo}</option>}
              </select>
              <button className="text-red-500 hover:text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              * नाव :
            </label>
            <div className="flex items-center gap-2">
              <select
                value={formData.selectedName}
                onChange={(e) => handleInputChange('selectedName', e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">निवडा</option>
                {formData.selectedName && <option value={formData.selectedName}>{formData.selectedName}</option>}
              </select>
              <button className="text-red-500 hover:text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
          <div className="flex items-end">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.showPropertyNo}
                onChange={(e) => handleInputChange('showPropertyNo', e.target.checked)}
                className="w-4 h-4 text-blue-600"
              />
              <span className="text-sm font-medium">* भोगवटधारकाच्या नावे</span>
            </label>
          </div>
        </div>

        {/* Table Label */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">तपशील</label>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-6">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-cyan-200">
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">कराचे नाव</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">थकबाकी</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">दंड</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">सूट</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">चालू</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">एकूण</th>
              </tr>
            </thead>
            <tbody>
              {/* घरपट्टी Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">घरपट्टी</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <div className="flex items-center gap-1">
                    <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                    <span className="text-gray-600">%</span>
                    <input type="text" className="w-16 px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                  </div>
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <div className="flex items-center gap-1">
                    <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                    <span className="text-gray-600">%</span>
                    <input type="text" className="w-16 px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                  </div>
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* दिवाबत्ती Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">दिवाबत्ती</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* आरोग्य Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">आरोग्य</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* Subtotal 1 */}
              <tr className="bg-pink-200">
                <td className="px-4 py-2 border border-gray-300 font-bold bg-cyan-100">एकूण</td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300 bg-pink-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-pink-100" placeholder="0" />
                </td>
              </tr>

              {/* इतर Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">इतर</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* सामान्य पाणीपुर्ती Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">सामान्य पाणीपुर्ती</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* विशेष पाणीपुर्ती Row */}
              <tr className="bg-white">
                <td className="px-4 py-2 border border-gray-300 font-medium bg-cyan-100">विशेष पाणीपुर्ती</td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-white" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-gray-100" placeholder="0" />
                </td>
              </tr>

              {/* Subtotal 2 */}
              <tr className="bg-pink-200">
                <td className="px-4 py-2 border border-gray-300 font-bold bg-cyan-100">एकूण</td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300 bg-pink-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-pink-100" placeholder="0" />
                </td>
              </tr>

              {/* Grand Total */}
              <tr className="bg-cyan-200">
                <td className="px-4 py-2 border border-gray-300 font-bold bg-cyan-100">एकूण</td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300"></td>
                <td className="px-4 py-2 border border-gray-300 bg-cyan-300">
                  <input type="text" className="w-full px-2 py-1 border border-gray-300 rounded bg-cyan-100 font-bold" placeholder="0" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded font-medium transition-colors"
          >
            जतन करा
          </button>
          <button
            onClick={handleReset}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-medium transition-colors"
          >
            नमुना न.९ नोदानी
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNamuna9;
